import { useFormikContext } from 'formik';

import { Button } from '../../cdl/Button/Button';
import { translate } from '../../common/helpers/translate.helper';
import { IconDownload } from '../../common/icons/cdl/Download';
import { Box } from '../../common/ui/Box';
import type { DemandDefinitionState } from '../types/DemandDefinitionState';
import type { DemandDefinitionSubstep } from '../types/DemandDefinitionSubstep';

interface DemandDefinitionFlowActionsProps {
    isExportDisabled: boolean;
    isExporting: boolean;
    isNextDisabled: boolean;
    isSaveDisabled: boolean;
    isSavingDraft: boolean;
    nextSubstep?: DemandDefinitionSubstep;
    onExport: () => void;
    onNext: (substep: DemandDefinitionSubstep) => void;
}

export const DemandDefinitionFlowActions = ({
    isExportDisabled,
    isExporting,
    isNextDisabled,
    isSaveDisabled,
    isSavingDraft,
    nextSubstep,
    onExport,
    onNext,
}: DemandDefinitionFlowActionsProps) => {
    const { isSubmitting, isValid, submitForm } = useFormikContext<DemandDefinitionState>();
    const isSaving = isSubmitting || isSavingDraft;

    if (!nextSubstep && !isSavingDraft) {
        return (
            <Box display="flex" gap={8}>
                <Button
                    LeadingIcon={IconDownload}
                    disabled={isExportDisabled}
                    isLoading={isExporting}
                    onClick={onExport}
                >
                    {translate('demandDefinition.exportToExcel')}
                </Button>
                <Button
                    emphasis="high"
                    disabled={!isValid || isSaveDisabled}
                    isLoading={isSubmitting}
                    onClick={submitForm}
                >
                    {translate('demandDefinition.saveDemandDefinition')}
                </Button>
            </Box>
        );
    }

    return (
        <Box display="flex" gap={8}>
            <Button disabled={!isValid || isSaveDisabled} isLoading={isSaving} onClick={submitForm}>
                {translate('demandDefinition.saveAsDraft')}
            </Button>
            {nextSubstep ? (
                <Button emphasis="high" disabled={isNextDisabled || isSaving} onClick={() => onNext(nextSubstep)}>
                    {translate('demandDefinition.nextStep')}
                </Button>
            ) : null}
        </Box>
    );
};
